export const CHART3_REQUEST = "CHART3_REQUEST";
export const CHART3_SUCCESS = "CHART3_SUCCESS";
export const CHART3_FAILURE = "CHART3_FAILURE";
